exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#years-to[data-v-1fe16208]:disabled{background:#eee}", ""]);

// exports
